import React, { useEffect, useState, useMemo } from 'react';
import { Table, Input, Typography, Button, Modal, Space, Popconfirm, message, Grid, Dropdown, Menu, Select, List, Card } from 'antd';
import axios from 'axios';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import {

  ShoppingCartOutlined, EllipsisOutlined, DownloadOutlined
} from '@ant-design/icons';

const { Title } = Typography;
const { Search } = Input;
const { useBreakpoint } = Grid;

const PedidosConModal = () => {
  const screens = useBreakpoint();
  const isMobile = !screens.md; // md = 768px
  const [pedidos, setPedidos] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [loading, setLoading] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  // Modal state
  const [modalVisible, setModalVisible] = useState(false);
  const [pedidoSeleccionado, setPedidoSeleccionado] = useState(null);
  console.log(pedidos)
  useEffect(() => {
    fetchPedidos();
  }, []);

  const fetchPedidos = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get('https://elarigestion-production.up.railway.app/api/pedidos', {
        headers: { Authorization: token },
      });
      const pedidosEntregado = res.data
        .filter((item) => item.entregado === false)
        .sort((a, b) => a.id - b.id); // ✅ Ordenar por ID ascendente

      setPedidos(pedidosEntregado);

    } catch (error) {
      console.error('Error al cargar pedidos', error);
    } finally {
      setLoading(false);
    }
  };

  const pedidosFiltrados = useMemo(() => {
    if (!searchText) return pedidos;
    const texto = searchText.toLowerCase();

    return pedidos.filter((pedido) => {
      const clienteMatch = pedido.cliente?.nombre_completo?.toLowerCase().includes(texto);
      const productosMatch = pedido.productos?.some((prod) =>
        prod.nombre.toLowerCase().includes(texto)
      );
      return clienteMatch || productosMatch;
    });
  }, [searchText, pedidos]);

  // Abrir modal detalles pedido
  const abrirModal = (pedido) => {
    setPedidoSeleccionado(pedido);
    setModalVisible(true);
  };

  const cerrarModal = () => {
    setPedidoSeleccionado(null);
    setModalVisible(false);
  };




  const exportToExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Pedidos');

    // Encabezados
    worksheet.columns = [
      { header: 'ID Pedido', key: 'id', width: 15 },
      { header: 'Cliente', key: 'cliente', width: 30 },
      { header: 'Correo electrónico', key: 'correo_electronico', width: 30 },
      { header: 'Teléfono', key: 'celular', width: 30 },


      { header: 'Fecha', key: 'fecha', width: 25 },
      { header: 'Estado', key: 'estado', width: 20 },
      { header: 'Productos', key: 'productos', width: 50 },
      { header: 'Total', key: 'total', width: 15 },
    ];

    pedidosFiltrados.forEach((pedido) => {
      worksheet.addRow({
        id: pedido.id,
        cliente: pedido.cliente?.nombre_completo || '-',
        correo_electronico: pedido.cliente?.correo_electronico || '-',
        celular: pedido.cliente?.celular || '-',


        fecha: new Date(pedido.fecha).toLocaleString(),
        total: `$${pedido.total}`,
        estado: pedido.entregado ? 'Entregado' : 'Pendiente',
        productos: pedido.productos?.map((p) => `${p.nombre} x${p.cantidad}`).join(', '),
      });
    });
    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber !== 1) {
        row.eachCell(cell => {
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
            indent: 1,
          };
        });
      }
    });
    // Estilo de encabezados
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '000000' }, // Negro
      };
      cell.font = { color: { argb: 'FFFFFF' }, bold: true }; // Blanco
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, 'Mis-Pedidos.xlsx');
  };
  const confirmarEntrega = async (pedidoId) => {
    try {
      const token = localStorage.getItem('token');

      await axios.put(`https://elarigestion-production.up.railway.app/api/pedidos/${pedidoId}/entregar`, {}, {
        headers: { Authorization: token }
      });

      // Actualizar la UI localmente
      setPedidos((prev) =>
        prev.map((p) =>
          p.id === pedidoId ? { ...p, entregado: true } : p
        )
      );

      message.success('Pedido marcado como entregado');
      fetchPedidos()
    } catch (error) {
      message.error('Error al actualizar el pedido');
      console.error(error);
    }
  };
  const handleMenuClick = (e) => {
    // Aquí puedes decidir si quieres cerrar el menú o no
    if (e.key === 'limpiar' || e.key === 'excel') {
      // Si quieres que se cierre, cierra el menú
      setDropdownVisible(false);
    } else {
      // Si quieres que no se cierre, no hagas nada o mantén abierto
    }
  };

  const handleVisibleChange = (flag) => {
    setDropdownVisible(flag);
  };
  const mobileMenu = (
    <Menu onClick={handleMenuClick}>

      <Menu.Item key="excel">
        <Button
          type="primary"
          onClick={exportToExcel}
          icon={<DownloadOutlined />}
          block
        >
          Exportar Excel
        </Button>
      </Menu.Item>
    </Menu>
  );
  return (
    <div >
      <div   
        style={{
                    display: 'flex',
                    flexDirection: isMobile ? 'row' : '',
                    alignItems: isMobile ? 'flex-start' : 'center',
                    justifyContent: 'space-between',
                    gap: '1rem',
                    marginBottom: 24,
                    padding: isMobile ? '20px' : 0,

                }} >
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>

        <Title level={3} style={{ margin: 0}}>
       
         📦 Pedidos Pendientes
        </Title>
                </div>

          <Dropdown overlay={mobileMenu} trigger={['click']} visible={dropdownVisible}
            onVisibleChange={handleVisibleChange}>
            <Button icon={<EllipsisOutlined />} />
          </Dropdown>



      </div>
      <div
   style={{ marginBottom: 16 }}
      >
        <Search
          placeholder="Buscar por cliente o producto"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          allowClear
             style={{
                        width: '100%',
                        maxWidth: '600px',
                        display: 'block',
                        padding: '0 10px',
                        boxSizing: 'border-box',
                    }}
        />

      </div>

      {isMobile ? (
        <List
          dataSource={pedidosFiltrados}
          loading={loading}
          rowKey="id"
          renderItem={(pedido) => (
            <Card
              style={{ marginBottom: 16 }}
              title={`Pedido #${pedido.id}`}
              extra={
                <span style={{ fontSize: 12, color: pedido.entregado ? 'green' : 'red' }}>
                  {pedido.entregado ? 'Entregado' : 'Pendiente'}
                </span>
              }
            >
              <p><strong>Cliente:</strong> {pedido.cliente?.nombre_completo || '-'}</p>
              <p><strong>Correo:</strong> {pedido.cliente?.correo_electronico || '-'}</p>
              <p><strong>Teléfono:</strong> {pedido.cliente?.celular || '-'}</p>
              <p><strong>Fecha:</strong> {new Date(pedido.fecha).toLocaleString()}</p>
              <p><strong>Total:</strong> ${pedido.total}</p>
              <p>
                <strong>Productos:</strong>{' '}
                {pedido.productos?.map((p) => `${p.nombre} x${p.cantidad}`).join(', ') || '-'}
              </p>

              <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
                <Button type="primary" onClick={() => abrirModal(pedido)}>
                  Ver pedido
                </Button>
                {!pedido.entregado && (
                  <Popconfirm
                    title="¿Confirmas que este pedido fue entregado?"
                    onConfirm={() => confirmarEntrega(pedido.id)}
                    okText="Sí"
                    cancelText="No"
                  >
                    <Button danger>Marcar entregado</Button>
                  </Popconfirm>
                )}
              </div>
            </Card>
          )}
        />
      ) : (
        <Table
          dataSource={pedidosFiltrados}
          rowKey="id"
          bordered
          loading={loading}
          pagination={{ pageSize: 10 }}
          size="middle"
          scroll={{ x: 'max-content' }}
        >
          <Table.Column title="ID Pedido" dataIndex="id" key="id" />
          <Table.Column
            title="Cliente"
            key="cliente"
            render={(_, record) => record.cliente?.nombre_completo || '-'}
          />
          <Table.Column
            title="Correo electrónico"
            key="correo_electronico"
            render={(_, record) => record.cliente?.correo_electronico || '-'}
          />
          <Table.Column
            title="Teléfono"
            key="celular"
            render={(_, record) => record.cliente?.celular || '-'}
          />
          <Table.Column
            title="Fecha del pedido"
            dataIndex="fecha"
            key="fecha"
            render={(fecha) => new Date(fecha).toLocaleString()}
          />
          <Table.Column
            title="Estado"
            dataIndex="entregado"
            key="entregado"
            render={(entregado) =>
              entregado ? (
                <span style={{ color: 'green', fontWeight: 'bold' }}>Entregado</span>
              ) : (
                <span style={{ color: 'red', fontWeight: 'bold' }}>Pendiente</span>
              )
            }
          />
          <Table.Column
            title="Acciones"
            key="acciones"
            render={(_, record) => (
              <Space>
                <Button type="primary" onClick={() => abrirModal(record)}>
                  Ver pedido
                </Button>
                {!record.entregado && (
                  <Popconfirm
                    title="¿Confirmas que este pedido fue entregado?"
                    onConfirm={() => confirmarEntrega(record.id)}
                    okText="Sí"
                    cancelText="No"
                  >
                    <Button danger>Marcar entregado</Button>
                  </Popconfirm>
                )}
              </Space>
            )}
          />
        </Table>
      )}


      <Modal
        title={`Detalle de Pedido #${pedidoSeleccionado?.id}`}
        visible={modalVisible}
        onCancel={cerrarModal}
        footer={[
          <Button key="cerrar" onClick={cerrarModal}>
            Cerrar
          </Button>,
        ]}
        width={600}
      >
        {pedidoSeleccionado ? (
          <>
            <p>
              <strong>Cliente:</strong> {pedidoSeleccionado.cliente?.nombre_completo}
            </p>
            <p>
              <strong>Fecha:</strong>{' '}
              {new Date(pedidoSeleccionado.fecha).toLocaleString()}
            </p>
            <p>
              <strong>Total:</strong> ${(pedidoSeleccionado.total)}
            </p>
            <Table
              dataSource={pedidoSeleccionado.productos}
              rowKey="id"
              pagination={false}
              size="small"
              bordered
            >
              <Table.Column title="Producto" dataIndex="nombre" key="nombre" />
              <Table.Column title="Cantidad" dataIndex="cantidad" key="cantidad" />
              <Table.Column
                title="Precio Unitario"
                dataIndex="precio_unitario"
                key="precio_unitario"
                render={(precio) => `$${precio}`}
              />
              <Table.Column
                title="Subtotal"
                key="subtotal"
                render={(_, producto) =>
                  `$${producto.precio_unitario * producto.cantidad}`
                }
              />
            </Table>
          </>
        ) : (
          <p>No hay detalles para mostrar.</p>
        )}
      </Modal>
    </div>
  );
};

export default PedidosConModal;
